import { useState, useEffect, useRef } from "react";
import { fetchCatalogDetailRequest } from "../../../redux/catalog/catalogSlice";

const tabs = [
  { key: "aims" },
  { key: "story" },
  { key: "impacts" },
];

const useCatalogDetail = ({
  entryId,
  dispatch,
  navigate,
  location,
  isAuthenticated,
}) => {
  const [favorites, setFavorites] = useState(new Set());
  const [activeTab, setActiveTab] = useState(0);

  const briefDescriptionRef = useRef(null);

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  const toggleFavorite = (entryId) => {
    if (!isAuthenticated) {
      navigate("/login");
      return;
    }

    const next = new Set(favorites);

    next.has(entryId)
      ? next.delete(entryId)
      : next.add(entryId);

    setFavorites(next);

    localStorage.setItem(
      "solutionsFavorites",
      JSON.stringify([...next])
    );
  };

  const handleBackClick = () => {
    if (location.state?.fromCatalogList) {
      navigate("/solutions/rural-development/solutions-catalog", {
        state: {
          searchQuery: location.state.searchQuery,
          selectedFilters: location.state.selectedFilters,
          currentPage: location.state.currentPage,
        },
      });
    } else {
      navigate("/solutions/rural-development/solutions-catalog");
    }
  };

  useEffect(() => {
    const saved = localStorage.getItem("solutionsFavorites");

    if (saved) {
      setFavorites(new Set(JSON.parse(saved)));
    }
  }, []);

  useEffect(() => {
    const saved = localStorage.getItem("solutionsFavorites");

    if (saved) {
      setFavorites(new Set(JSON.parse(saved)));
    }
  }, []);

  useEffect(() => {
    if (entryId) {
      dispatch(fetchCatalogDetailRequest({ entryId }));
    }
  }, [entryId, dispatch]);

  return {
    favorites,
    activeTab,
    briefDescriptionRef,
    handleTabChange,
    toggleFavorite,
    handleBackClick,
  };
};

export default useCatalogDetail;